import React from 'react';
import { Form, Input } from 'antd';
import { useTheme } from 'styled-components';
import CpscCoreForm from 'components/CpscCoreForm';
import { FormItem } from '@xbcb/form-item-components';
import { PgaFormBaseProps } from 'types';
import { StyledCpscFormDiv } from './styles';

export interface CpscFormProps extends PgaFormBaseProps {
  packagingLevelsOverride?: number;
}

const CpscForm: React.FC<CpscFormProps> = ({
  fullNamePath,
  localNamePath,
  readOnly,
  required,
  disabled,
}) => {
  const theme = useTheme();
  const form = Form.useFormInstance();
  const lineDescriptionPath = [...fullNamePath.slice(0, -1), 'description'];
  const cbpDescription = Form.useWatch(lineDescriptionPath, form);

  return (
    <StyledCpscFormDiv>
      <FormItem
        label="CBP Description"
        $itemSize={theme.size.medium}
        $readOnly={true}
      >
        <Input.TextArea
          autoSize
          disabled={true}
          maxLength={20000}
          placeholder="<CBP description pulled from CI>"
          value={cbpDescription || ''}
        />
      </FormItem>
      <CpscCoreForm
        fullNamePath={fullNamePath}
        localNamePath={localNamePath}
        readOnly={readOnly}
        required={required}
        disabled={disabled}
      />
    </StyledCpscFormDiv>
  );
};

export default CpscForm;
